import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";
import auth from "./modules/auth/store";
import customers from "./modules/customers";
import documents from "./modules/documents";
import shop from "./modules/shop/store";
import team from "./modules/team";
import mediaCollection from "./modules/mediaCollection/store"
import merchants from "./modules/merchants/store";
import orders from "./modules/orders/store";
import orderStatusOptions from "./modules/orderStatusOptions/store";
import printers from "./modules/printers";
import productCategories from "./modules/productCategories/store";
import productCollections from "./modules/productCollections/store";
import products from "./modules/products/store";
import profile from "./modules/profile";
import settings from "./modules/settings";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    customers,
    documents,
    mediaCollection,
    merchants,
    orders,
    orderStatusOptions,
    printers,
    products,
    productCategories,
    productCollections,
    profile,
    settings,
    shop,
    team
  }
});
